// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-header {
  background-color: #FF8C00 !important;
}

input[type="text"] {
  letter-spacing: 8px;
  font-weight: bold;
  font-size: 1.5rem;
}

.btn-primary {
  background-color: #FF8C00;
  border-color: #FF8C00;
}

.btn-primary:hover {
  background-color: #E67E00;
  border-color: #E67E00;
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}

.btn-outline-secondary:hover {
  background-color: #6c757d;
  color: white;
}

.btn-link {
  color: #FF8C00;
  text-decoration: none;
}

.btn-link:hover {
  color: #E67E00;
  text-decoration: underline;
}

/* Estilos para centrar y mejorar apariencia */
.auth-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 1000;
}

.verify-2fa-container {
  width: 100%;
  max-width: 400px; /* Tamaño en móvil */
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Tamaños responsivos para diferentes dispositivos */
@media (min-width: 768px) {
  .verify-2fa-container {
    max-width: 450px; /* Tamaño en tablet */
  }
}

@media (min-width: 992px) {
  .verify-2fa-container {
    max-width: 480px; /* Tamaño en desktop */
  }
}

@media (min-width: 1200px) {
  .verify-2fa-container {
    max-width: 500px; /* Tamaño en pantallas grandes */
  }
}

/* Modal overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

/* Modal container */
.verify-2fa-modal {
  background: white;
  border-radius: 16px;
  padding: 0;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  position: relative;
  overflow: hidden;
}

/* Modal header */
.modal-header {
  position: relative;
  padding: 16px 20px 0;
  display: flex;
  justify-content: flex-end;
}

.close-button {
  background: none;
  border: none;
  font-size: 20px;
  color: #6b7280;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s;
}

.close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}

/* Modal content */
.modal-content {
  padding: 20px 40px 40px;
  text-align: center;
}

/* Icon container */
.icon-container {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

.check-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #fde68a 0%, #f59e0b 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 28px;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

/* Typography */
.modal-title {
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 20px 0 !important;
  line-height: 1.3;
}

.modal-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 32px 0;
  line-height: 1.5;
}

/* Field label */
.field-label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 20px !important;
  text-align: left;
}

/* Code inputs container */
.code-inputs {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 16px !important;
  margin-bottom: 32px;
}

/* Individual digit inputs */
.digit-input {
  width: 48px;
  height: 56px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  background: white;
  transition: all 0.2s;
  outline: none;
}

.digit-input:focus {
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);
}

/* Verify button */
.verify-button {
  width: 100%;
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  border: none;
  border-radius: 12px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 24px;
  position: relative;
  overflow: hidden;
}

.verify-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 10px 25px -5px rgba(245, 158, 11, 0.4);
}

.verify-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Spinner */
.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
  margin-right: 8px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Separator */
.separator {
  position: relative;
  margin: 24px 0;
  text-align: center;
}

.separator::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: #e5e7eb;
}

.separator span {
  background: white;
  padding: 0 16px;
  font-size: 14px;
  color: #6b7280;
  position: relative;
}

/* Backup link */
.backup-link {
  background: none;
  border: none;
  color: #3b82f6;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s;
}

.backup-link:hover {
  color: #2563eb;
  text-decoration: underline;
}

/* Backup form */
.backup-form {
  margin-top: 20px;
}

.backup-description {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 24px;
  line-height: 1.5;
}

.backup-input-container {
  margin-bottom: 24px;
  text-align: left;
}

.backup-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 16px;
  color: #111827;
  background: white;
  transition: all 0.2s;
  outline: none;
  text-align: center;
  letter-spacing: 2px;
  font-weight: 600;
  text-transform: uppercase;
}

.backup-input:focus {
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);
}

.back-button {
  background: none;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 12px;
}

.back-button:hover {
  border-color: #d1d5db;
  color: #374151;
}

/* Responsive design */
@media (max-width: 480px) {
  .modal-content {
    padding: 20px 24px 32px;
  }
  
  .code-inputs {
    gap: 8px;
  }
  
  .digit-input {
    width: 40px;
    height: 48px;
    font-size: 18px;
  }
  
  .modal-title {
    font-size: 20px;
  }
  
  .check-icon {
    width: 64px;
    height: 64px;
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/auth/verify-2fa/verify-2fa.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,oBAAoB;EACtC,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA,qDAAqD;AACrD;EACE;IACE,gBAAgB,EAAE,qBAAqB;EACzC;AACF;;AAEA;EACE;IACE,gBAAgB,EAAE,sBAAsB;EAC1C;AACF;;AAEA;EACE;IACE,gBAAgB,EAAE,gCAAgC;EACpD;AACF;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,qFAAqF;EACrF,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".card {\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.card-header {\n  background-color: #FF8C00 !important;\n}\n\ninput[type=\"text\"] {\n  letter-spacing: 8px;\n  font-weight: bold;\n  font-size: 1.5rem;\n}\n\n.btn-primary {\n  background-color: #FF8C00;\n  border-color: #FF8C00;\n}\n\n.btn-primary:hover {\n  background-color: #E67E00;\n  border-color: #E67E00;\n}\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-outline-secondary:hover {\n  background-color: #6c757d;\n  color: white;\n}\n\n.btn-link {\n  color: #FF8C00;\n  text-decoration: none;\n}\n\n.btn-link:hover {\n  color: #E67E00;\n  text-decoration: underline;\n}\n\n/* Estilos para centrar y mejorar apariencia */\n.auth-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  z-index: 1000;\n}\n\n.verify-2fa-container {\n  width: 100%;\n  max-width: 400px; /* Tamaño en móvil */\n  margin: 0 auto;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n/* Tamaños responsivos para diferentes dispositivos */\n@media (min-width: 768px) {\n  .verify-2fa-container {\n    max-width: 450px; /* Tamaño en tablet */\n  }\n}\n\n@media (min-width: 992px) {\n  .verify-2fa-container {\n    max-width: 480px; /* Tamaño en desktop */\n  }\n}\n\n@media (min-width: 1200px) {\n  .verify-2fa-container {\n    max-width: 500px; /* Tamaño en pantallas grandes */\n  }\n}\n\n/* Modal overlay */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n/* Modal container */\n.verify-2fa-modal {\n  background: white;\n  border-radius: 16px;\n  padding: 0;\n  width: 100%;\n  max-width: 480px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  position: relative;\n  overflow: hidden;\n}\n\n/* Modal header */\n.modal-header {\n  position: relative;\n  padding: 16px 20px 0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.close-button:hover {\n  background-color: #f3f4f6;\n  color: #374151;\n}\n\n/* Modal content */\n.modal-content {\n  padding: 20px 40px 40px;\n  text-align: center;\n}\n\n/* Icon container */\n.icon-container {\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: center;\n}\n\n.check-icon {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, #fde68a 0%, #f59e0b 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 28px;\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);\n}\n\n/* Typography */\n.modal-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 20px 0 !important;\n  line-height: 1.3;\n}\n\n.modal-subtitle {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0 0 32px 0;\n  line-height: 1.5;\n}\n\n/* Field label */\n.field-label {\n  display: block;\n  font-size: 16px;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 20px !important;\n  text-align: left;\n}\n\n/* Code inputs container */\n.code-inputs {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  margin-top: 16px !important;\n  margin-bottom: 32px;\n}\n\n/* Individual digit inputs */\n.digit-input {\n  width: 48px;\n  height: 56px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  text-align: center;\n  font-size: 20px;\n  font-weight: 600;\n  color: #111827;\n  background: white;\n  transition: all 0.2s;\n  outline: none;\n}\n\n.digit-input:focus {\n  border-color: #f59e0b;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);\n}\n\n/* Verify button */\n.verify-button {\n  width: 100%;\n  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);\n  border: none;\n  border-radius: 12px;\n  padding: 16px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-bottom: 24px;\n  position: relative;\n  overflow: hidden;\n}\n\n.verify-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 25px -5px rgba(245, 158, 11, 0.4);\n}\n\n.verify-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Spinner */\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid transparent;\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  display: inline-block;\n  margin-right: 8px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Separator */\n.separator {\n  position: relative;\n  margin: 24px 0;\n  text-align: center;\n}\n\n.separator::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: #e5e7eb;\n}\n\n.separator span {\n  background: white;\n  padding: 0 16px;\n  font-size: 14px;\n  color: #6b7280;\n  position: relative;\n}\n\n/* Backup link */\n.backup-link {\n  background: none;\n  border: none;\n  color: #3b82f6;\n  font-size: 14px;\n  cursor: pointer;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.backup-link:hover {\n  color: #2563eb;\n  text-decoration: underline;\n}\n\n/* Backup form */\n.backup-form {\n  margin-top: 20px;\n}\n\n.backup-description {\n  font-size: 14px;\n  color: #6b7280;\n  margin-bottom: 24px;\n  line-height: 1.5;\n}\n\n.backup-input-container {\n  margin-bottom: 24px;\n  text-align: left;\n}\n\n.backup-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 16px;\n  color: #111827;\n  background: white;\n  transition: all 0.2s;\n  outline: none;\n  text-align: center;\n  letter-spacing: 2px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.backup-input:focus {\n  border-color: #f59e0b;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);\n}\n\n.back-button {\n  background: none;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 12px 24px;\n  font-size: 14px;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-top: 12px;\n}\n\n.back-button:hover {\n  border-color: #d1d5db;\n  color: #374151;\n}\n\n/* Responsive design */\n@media (max-width: 480px) {\n  .modal-content {\n    padding: 20px 24px 32px;\n  }\n  \n  .code-inputs {\n    gap: 8px;\n  }\n  \n  .digit-input {\n    width: 40px;\n    height: 48px;\n    font-size: 18px;\n  }\n  \n  .modal-title {\n    font-size: 20px;\n  }\n  \n  .check-icon {\n    width: 64px;\n    height: 64px;\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
